import OneColumn from './OneColumn.component';

export default OneColumn;
